import _ from 'lodash';
import { GET_PROFILE_EVENT_PROGRESS, GET_EVENT } from '~components/hooks';
import { Event as EventType, EventUser as EventUserType } from '~types';
import { FieldFunctionOptions } from '@apollo/client';

export const EventUser = {};
